import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import * as _ from 'lodash';
import { lastValueFrom, Observable, Subject } from 'rxjs';
import { environment } from '../../environments/environment';
import { User } from '../models/user';

@Injectable()
export class AuthorizationService {
  private healthcareTopBar: any;
  private readonly CHECK_IF_TOPBAR_HAS_LOADED_INTERVAL = 1000;
  private features: any[] = [];
  private timer!: ReturnType<typeof setInterval>;

  private topBarLoaded = false;
  private readyResolved = false;

  private healthcareLoadedSubject = new Subject<void>();
  public healthcareLoadedSubject$ = this.healthcareLoadedSubject.asObservable();

  private _readyResolve!: () => void;
  readonly ready = new Promise<void>((res) => (this._readyResolve = res));

  constructor(private http: HttpClient) {
    this.timer = setInterval(() => {
      this.waitForTopBarToLoad();
    }, this.CHECK_IF_TOPBAR_HAS_LOADED_INTERVAL);
  }

  public setHealthcareTopBar(topBar: any): void {
    this.healthcareTopBar = topBar;

    this.waitForTopBarToLoad();
  }

  public get HealthcareTopBar(): any {
    return this.healthcareTopBar ?? null;
  }

  public get hasTopBarLoaded(): boolean {
    return this.topBarLoaded;
  }

  public async waitUntilReady(): Promise<void> {
    return this.ready;
  }

  public async isAuthenticated(): Promise<boolean> {
    await this.waitUntilReady();
    return this.healthcareTopBar.healthcareAuth.isAuthenticated();
  }

  public hasFeature(featureName: string, useCache: boolean = false): boolean {
    if (!this.healthcareTopBar?.currentUserDetails) return false;

    const collection: any[] = useCache
      ? this.features
      : this.healthcareTopBar.currentUserDetails?.Features ?? [];

    const appName = environment.applicationNameBi;
    const appAccessFeature = environment.applicationAccessFeature;

    const foundBoth = [featureName, appAccessFeature].every((name) =>
      collection.some((f) => f.App === appName && f.Name === name)
    );

    return foundBoth;
  }

  CurrentUser(): Promise<User> {
    return lastValueFrom(
      this.http.get<User>(environment.authZApiRoot.url + '/CurrentUser')
    );
  }

  GetLookerUrl(clientId: string, slugId: string): Observable<any> {
    let authheaders = new HttpHeaders();

    authheaders = authheaders
      .set('Content-Type', 'application/json')
      .set('Access-Control-Allow-Origin', '*')
      .set(
        'Access-Control-Allow-Methods',
        'GET, POST, OPTIONS, PUT, PATCH, DELETE'
      );

    return this.http.get<any>(
      `${environment.authZApiRoot.url}/LookerUrl/Clients/${clientId}/slugIds/${slugId}`,
      { headers: authheaders }
    );
  }

  private waitForTopBarToLoad(): boolean {
    if (!this.healthcareTopBar?.currentUserDetails) {
      return false;
    }

    const all = this.healthcareTopBar.currentUserDetails?.Features ?? [];
    this.features = all.filter(
      (obj: any) =>
        obj?.App === environment.applicationNameBi ||
        obj?.App === environment.applicationNameBi
    );

    this.topBarLoaded = true;

    if (!this.readyResolved) {
      this.readyResolved = true;
      this._readyResolve?.();
    }

    this.healthcareLoadedSubject.next();

    clearInterval(this.timer);
    return true;
  }
}
